var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ace-editor-ba"},[_c('div',{staticClass:"form-control",style:(("height: " + (_vm.height ? _vm.height : 400) + "px;")),attrs:{"id":("ace-code-editor-" + (this.editorId))}},[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1982b1fb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/components/AceCodeEditor.vue
// module id = null
// module chunks = 